import { render, staticRenderFns } from "./Vehicles.vue?vue&type=template&id=5766b5f2"
import script from "./Vehicles.vue?vue&type=script&lang=ts"
export * from "./Vehicles.vue?vue&type=script&lang=ts"
import style0 from "./Vehicles.vue?vue&type=style&index=0&id=5766b5f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports